// Scripts level Theme customisation goes here

window.onWizzyScriptLoaded = function () {
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (payload) {
      // payload.common.lazyDOMConfig.searchInputIdentifiers[0].dom =
      //   ".wizzy-input-search-box input";
      payload.common.lazyDOMConfig.searchInputIdentifiers[0].dom = "#search";

      payload.common.lazyDOMConfig.searchInputIdentifiers[0].type = "search";
      payload.autocomplete.pages.title = "Blogs";
      var noProductsFound = JSON.parse(
        '{"showProducts": true,"defaultPool":{"method":"filters","expiry":"session","data":{"productsCount":6,"categories": ["our-bestsellers"]}}}'
      );
      payload["search"]["view"]["noProductsFoundDOM"] = ".wizzy-main-content";
      payload["search"]["configs"]["noProductsFound"] = noProductsFound;

      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (payload) {
      if (payload.group === "defaultMenu") {
        payload.filters = {
          categories: ["our-bestsellers"],
          facets: [
            {
              label: "Category",
              key: "categories",
              position: "left",
              order: 0,
            },
            {
              label: "Sub-Category",
              key: "product_product_type",
              position: "left",
              order: 1,
            },
            { label: "Price", key: "sellingPrice", position: "left", order: 2 },
            { label: "Color", key: "colors", position: "left", order: 3 },
            { label: "Gender", key: "genders", position: "left", order: 4 },
          ],
          swatch: [],
          currency: "INR",
          productsCount: 6,
          sort: [{ field: "relevance", order: "asc" }],
        };
      }

      if (window.innerWidth < 768) {
        $(".wizzy-autocomplete-wrapper").scrollTop(-20000);
      }

      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_RESULTS_RENDERED,
    function (payload) {
      // alert("Product result rendered")
      var x = document.getElementsByClassName(
        "wizzy-custom-search-form-wrapper"
      )[0];

      if (window.innerWidth >= 768) {
        if (!x.classList.contains("wizzyOpacityNone")) {
          document.getElementsByClassName("wizzy-input-touch")[0].click();
        }
      } else {
        document.getElementsByClassName("wizzy-search-back")[0].click();
      }

      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (payload) {

      if(window.innerWidth < 768) {
        if(payload.data.api === "autocomplete") {
          $(".wizzy-autocomplete-wrapper").animate({
             scrollTop:-20000
          });
        }
      }

      if (payload.data.api === "autocomplete") {
        blogPostLoad(
          payload.data.response.payload.products.filters.q,
          "autocomplete",
          payload.data.response.payload.products.total
        );   
      }

      if (payload.data.api === "search") {
        blogPostLoad(
          payload.data.response.payload.filters.q,
          "search",
          payload.data.response.payload.total
        );
      }
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (data) {
      var countTotalProducts = 0;
      var n = data.length;
      for (let i = 0; i < n; i++) {
        let m = data[i].attributes.length;
        for (let j = 0; j < m; j++) {
          var s = "";
          if (data[i].attributes[j].id === "product_StarRatingSnippet_okendo") {
            s = data[i].attributes[j].values[0].value[0];
            var $s = $($.parseHTML(s));
            data[i].reviewHTML = $s[0].innerHTML;
            // var $s = $($.parseHTML($s[0].innerHTML));
            // text = $s.filter("script").text();

            // var rattingInfo = JSON.parse(text);

            // data[i].avgRatings = rattingInfo.averageRating;
            // data[i].totalReviews = rattingInfo.reviewCount;
          } else if (
            data[i].attributes[j].id ===
            "product_bestseller_product_titles_custom"
          ) {
            s = data[i].attributes[j].values[0].value[0];
            data[i].displayTitle = s;
            // let dyEle = s.search("<span>");
            // if (dyEle == -1) {
            //   data[i].itemTobeDisplayed = false;
            // } else {
            //   data[i].itemTobeDisplayed = true;
            //   countTotalProducts += 1;
            // }
            // console.log(dyEle,'<=======dyEle');
          } else if (
            data[i].attributes[j].id ===
            "product_bestseller_short_desc_on_home_custom"
          ) {
            s = data[i].attributes[j].values[0].value[0];
            data[i].itemDesc = s;
          } else if (data[i].attributes[j].id === "product_badge_custom") {
            s = data[i].attributes[j].values[0].value[0];
            data[i].newBadge = s;
          }
        }
      }

      return data;
    }
  );

  $(document).ready(function () {
    $("body").on("click", ".wizzy-input-touch", function () {
      var x = document.getElementsByClassName(
        "wizzy-custom-search-form-wrapper"
      )[0];

      if (window.innerWidth >= 768) {
        if (x.classList.contains("wizzyOpacityNone")) {
          x.classList.add("wizzy-custom-search-bar");
          x.classList.remove("wizzyOpacityNone");
          $(".wizzyPageOverlay").css("display", "block");
          $(".wizzy-search-input").focus();
          // document.getElementsByClassName("wizzy-search-input")[0].click();
        } else if (x.classList.contains("wizzy-custom-search-bar")) {
          x.classList.remove("wizzy-custom-search-bar");
          $(".wizzyPageOverlay").css("display", "none");
          x.classList.add("wizzyOpacityNone");
        } else {
          x.classList.add("wizzy-custom-search-bar");
          $(".wizzyPageOverlay").css("display", "block");
        }
      } else {
        if (x.classList.contains("wizzyOpacityNone")) {
          x.classList.remove("wizzyOpacityNone");
        }

        if (x.classList.contains("wizzy-custom-search-bar")) {
          x.classList.remove("wizzy-custom-search-bar");
          $("body").removeClass("wizzy-mobile-scroll-fix");
        } else {
          x.classList.add("wizzy-custom-search-bar");
          $("body").addClass("wizzy-mobile-scroll-fix");
          $(".wizzy-search-input").focus();
        }
      }
    });

    $("body").on("click", ".wizzyPageOverlay", function () {
      if (window.innerWidth >= 768) {
        var x = document.getElementsByClassName(
          "wizzy-custom-search-form-wrapper"
        )[0];
        if (x.classList.contains("wizzy-custom-search-bar")) {
          x.classList.remove("wizzy-custom-search-bar");
          $(".wizzyPageOverlay").css("display", "none");
          x.classList.add("wizzyOpacityNone");
        }
      } else {
        $(".wizzyPageOverlay").css("display", "none");
      }
    });

    $("body").on("click", ".wizzy-search-back", function () {
      if (window.innerWidth < 768) {
        var x = document.getElementsByClassName(
          "wizzy-custom-search-form-wrapper"
        )[0];
        x.classList.add("wizzyOpacityNone");
        x.classList.remove("wizzy-custom-search-bar");
        $("body").removeClass("wizzy-mobile-scroll-fix");
      }
    });

    $("body").on("click", ".wizzy-search-input", function () {
      if (window.innerWidth < 768) {
        $(".wizzy-custom-search-form-wrapper").removeClass("mobileTapped");
        setTimeout(()=>{
          $(".wizzy-autocomplete-wrapper").scrollTop(-20000);
        },200)
      }
    });

   

    changeTemplate("wizzy-search-results-product");
    changeTemplate("wizzy-autocomplete-topproducts");
    changeTemplate("wizzy-autocomplete-suggestions");
    changeTemplate("wizzy-search-empty-results");
    changeTemplate("wizzy-search-wrapper");
    WizzyAddToSearch();
    observerHeader();
  });
};

function observerHeader() {
  let observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutationRecord) {
      // console.log($(mutationRecord.target).hasClass('sticky'),'<=======has Stick')
      if ($(mutationRecord.target).hasClass("sticky")) {
        $("body").addClass("wizzyStick");
      } else {
        $("body").removeClass("wizzyStick");
      }
    });
  });

  let target = document.getElementById("shopify-section-header");
  observer.observe(target, { attributes: true, attributeFilter: ["class"] });
}

function WizzyAddToSearch() {
  $(document).ready(function () {
    if (window.innerWidth < 768) {
      $("body").on("click", ".autocomplete-text-wrapper", function (e) {
        // console.log("Clicked");
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        var query = $(this).parent().attr("data-searchterm");
        $("#search").val(query);
        $("#search").focus();
      });
    }
  });
}

const changeTemplate = (div) => {
  let newDiv = document.getElementById(div + "-new").text;
  let oldDiv = document.getElementById(div);
  oldDiv.text = newDiv;
};

function blogPostLoad(q, task, count) {
  $.ajax({
    type: "GET",
    url: `https://mymuse.in/search?q=${q}&type=article,page&section_id=search-blogs`,
    data: { q: q, type: "article,page", section_id: "search-blogs" },
    success: function (response) {
      var resultBlogItem =
        ".wizzy-blog-results #shopify-section-search-blogs .page #shopify-section-blog-template .halo-column .halo-column__item .featured-blog";
      var resultBlogImage =
        ".wizzy-blog-results #shopify-section-search-blogs .page #shopify-section-blog-template .halo-column .halo-column__item .featured-blog .featured-blog__image";
      var resultBlogContent =
        ".wizzy-blog-results #shopify-section-search-blogs .page #shopify-section-blog-template .halo-column .halo-column__item .featured-blog .featured-blog__content";

      if (task === "search" && count) {
        $(".wizzy-blog-results").html(response);

        $(
          ".wizzy-blog-results #shopify-section-search-blogs .wizzy-autocomplete-blog-title"
        ).html("Results from Blogs");
      }

      var autocompleteImage =
        ".wizzy-autocomplete-suggestions .wizzy-autocomplete-blogs-1 #shopify-section-search-blogs .page #shopify-section-blog-template .halo-column .halo-column__item .featured-blog .featured-blog__image";

      var autocompleteExcerpt =
        ".wizzy-autocomplete-suggestions .wizzy-autocomplete-blogs-1 #shopify-section-search-blogs .page #shopify-section-blog-template .halo-column .halo-column__item .featured-blog .featured-blog__content .featured-blog__excerpt";
      var autocompleteBlogContent =
        ".wizzy-autocomplete-suggestions .wizzy-autocomplete-blogs-1 #shopify-section-search-blogs .page #shopify-section-blog-template .halo-column .halo-column__item .featured-blog .featured-blog__content";

      var autocompleteBlogTitle =
        ".wizzy-autocomplete-suggestions .wizzy-autocomplete-blogs-1 #shopify-section-search-blogs .page #shopify-section-blog-template .halo-column .halo-column__item .featured-blog .featured-blog__content .featured-blog__title";

      var autocompleteBlogReadButton = 
        ".wizzy-autocomplete-suggestions .wizzy-autocomplete-blogs-1 #shopify-section-search-blogs .page #shopify-section-blog-template .halo-column .halo-column__item .featured-blog .featured-blog__content .featured-blog__button"

      var autocompleteImage_2 =
        ".wizzy-autocomplete-blogs-2 #shopify-section-search-blogs .page #shopify-section-blog-template .halo-column .halo-column__item .featured-blog .featured-blog__image";

      var autocompleteExcerpt_2 =
        ".wizzy-autocomplete-blogs-2 #shopify-section-search-blogs .page #shopify-section-blog-template .halo-column .halo-column__item .featured-blog .featured-blog__content .featured-blog__excerpt";
      var autocompleteBlogContent_2 =
        ".wizzy-autocomplete-blogs-2 #shopify-section-search-blogs .page #shopify-section-blog-template .halo-column .halo-column__item .featured-blog .featured-blog__content";

      var autocompleteBlogTitle_2 =
        ".wizzy-autocomplete-blogs-2 #shopify-section-search-blogs .page #shopify-section-blog-template .halo-column .halo-column__item .featured-blog .featured-blog__content .featured-blog__title";

      var autocompleteBlogReadButton_2 = 
        ".wizzy-autocomplete-blogs-2 #shopify-section-search-blogs .page #shopify-section-blog-template .halo-column .halo-column__item .featured-blog .featured-blog__content .featured-blog__button"


      
      if (task === "autocomplete") {
        var flag1 = document.querySelectorAll(".withoutSuggestions")[0];
        var flag2 = document.querySelectorAll(".withoutTopProducts")[0];
        if(flag1 != undefined && flag2 != undefined) {
          console.log("<== this is not correct");
          var currentAutocomplete = ".wizzy-autocomplete-wrapper.withoutTopProducts.withoutSuggestions";
          $(currentAutocomplete).addClass("onlyBlogs");
          $(".wizzy-autocomplete-blogs-2").html(response);
          $(autocompleteImage_2).css("display", "none");
          $(autocompleteExcerpt_2).css("display", "none");
          $(autocompleteBlogReadButton_2).css("display", "none");
          $(autocompleteBlogContent_2).css("padding", "0px");
        }else if(flag1 != undefined) {
          $(".wizzy-autocomplete-blogs-2").html(response);
          $(autocompleteImage_2).css("display", "none");
          $(autocompleteExcerpt_2).css("display", "none");
          $(autocompleteBlogReadButton_2).css("display", "none");
          $(autocompleteBlogContent_2).css("padding", "0px");
        }else {
          $(".wizzy-autocomplete-blogs-1").html(response);
          $(autocompleteImage).css("display", "none");
          $(autocompleteExcerpt).css("display", "none");
          $(autocompleteBlogReadButton).css("display", "none");
          $(autocompleteBlogContent).css("padding", "0px");
        }
        
        setTimeout(()=>{
          $(".wizzy-autocomplete-wrapper").scrollTop(-20000);
        },200);
      }
    },
    error: function (xhr, ajaxOptions, thrownError) {
      alert(xhr.status);
      alert(thrownError);
    },
  });

  return false;
}
